module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"authErrorPageTitle":"Authorization Error","authErrorTitle":"Authorization Error","authErrorText":"Check your login and password and try again","authErrorButton":"Return to Home"}}')
  delete Component.options._Ctor
}
